import { render, staticRenderFns } from "./nbHandle.vue?vue&type=template&id=ab787dbe&scoped=true"
import script from "./nbHandle.vue?vue&type=script&lang=js"
export * from "./nbHandle.vue?vue&type=script&lang=js"
import style0 from "./nbHandle.vue?vue&type=style&index=0&id=ab787dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab787dbe",
  null
  
)

export default component.exports